import type {Suggestion, Suggestions} from '@github-ui/inline-autocomplete/types'
import {useMemo} from 'react'

import {topLevelCategories} from './categories'
import {CategorySuggestion} from './CategorySuggestion'

export interface CategoriesQuery {
  category: 'categories'
  filter: string
}

export function useCategoriesSuggestions(query: CategoriesQuery | null) {
  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    return topLevelCategories
      .filter(category => category.name.toLowerCase().includes(query.filter.toLowerCase()))
      .map<Suggestion>(category => ({
        value: null,
        key: category.value,
        render: props => <CategorySuggestion category={category} {...props} />,
      }))
  }, [query])
}
